module.exports = __webpack_public_path__ + "img/fruct24_demo.6689ffc8.jpg";